import { token } from '@thiememeulenhoff/lit-sdk';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const SCORE_LEVEL_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-background-default'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-background-default'),
  [ScoreLevel.Marginal]: token('score-label-warning-background-default'),
  [ScoreLevel.Satisfactory]: token('score-label-success-background-default'),
  [ScoreLevel.Excellent]: token('score-label-success-background-default'),
};

export const SCORE_LEVEL_COLOR_HOVER_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-background-hover'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-background-hover'),
  [ScoreLevel.Marginal]: token('score-label-warning-background-hover'),
  [ScoreLevel.Satisfactory]: token('score-label-success-background-hover'),
  [ScoreLevel.Excellent]: token('score-label-success-background-hover'),
};

export const SCORE_LEVEL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-foreground-default'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-foreground-default'),
  [ScoreLevel.Marginal]: token('score-label-warning-foreground-default'),
  [ScoreLevel.Satisfactory]: token('score-label-success-foreground-default'),
  [ScoreLevel.Excellent]: token('score-label-success-foreground-default'),
};

export const SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> =
  {
    [ScoreLevel.Poor]: token('score-label-error-neutral-foreground-default'),
    [ScoreLevel.Unsatisfactory]: token(
      'score-label-warning-neutral-foreground-default',
    ),
    [ScoreLevel.Marginal]: token(
      'score-label-warning-neutral-foreground-default',
    ),
    [ScoreLevel.Satisfactory]: token(
      'score-label-success-neutral-foreground-default',
    ),
    [ScoreLevel.Excellent]: token(
      'score-label-success-neutral-foreground-default',
    ),
  };

export const SCORE_LEVEL_ICON_MAP: Record<ScoreLevel, string> = {
  [ScoreLevel.Poor]: 'close',
  [ScoreLevel.Unsatisfactory]: 'wave-triangle',
  [ScoreLevel.Marginal]: 'wave-triangle',
  [ScoreLevel.Satisfactory]: 'check',
  [ScoreLevel.Excellent]: 'check',
};

export const SCORE_LEVEL_BORDER_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-border-default'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-border-default'),
  [ScoreLevel.Marginal]: token('score-label-warning-border-default'),
  [ScoreLevel.Satisfactory]: token('score-label-success-border-default'),
  [ScoreLevel.Excellent]: token('score-label-success-border-default'),
};
